import NavigationLayout from "../navigation/navigation-layout.js";
import SectionLayout from '../../layouts/section-layout.js';
import FooterLayout from '../footer/footer-layout.js';
import PolicyView from "./policy-view.js";
import { useEffect } from "react";

const PoliciesLayout = ({
    json
}) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <NavigationLayout />

            <SectionLayout children={<PolicyView data={json}/>}/>

            <FooterLayout />
        </>
    );
}

export default PoliciesLayout;